import React from 'react';
import useLanguagesHooks from '../../../../../../../../../Components/Languages/setLanguage-hooks';
import { DineInQrStatus } from '../../../../../../../../../Interfaces/componentTypes';
import { IDineInUnit } from '../../../../../../../../../Interfaces/responseTypes';
import { getUnitQrStatusMeta } from '../dineInHelpers';
import styles from './unitQrStatusBadge.module.scss';

interface IUnitQrStatusBadgeProps {
    unit: IDineInUnit;
}

const StatusIcon: React.FC<{ status: DineInQrStatus }> = ({ status }) => {
    if (status === DineInQrStatus.GENERATED) {
        return (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <path d="M8 12.5L10.5 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        );
    }

    if (status === DineInQrStatus.PARTIAL) {
        return (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <circle cx="12" cy="16" r="1" fill="currentColor" />
                <path d="M10.29 3.86L1.82 18A2 2 0 003.64 21H20.36A2 2 0 0022.18 18L13.71 3.86A2 2 0 0010.29 3.86Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
            </svg>
        );
    }

    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" strokeDasharray="4 3" />
            <path d="M12 7V12L15 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

const UnitQrStatusBadge: React.FC<IUnitQrStatusBadgeProps> = ({ unit }) => {
    const { t } = useLanguagesHooks();
    const meta = getUnitQrStatusMeta(unit);

    return (
        <div className={`${styles.panel} ${styles[`panel_${meta.status}`]}`}>
            <div className={styles.iconWrap}>
                <StatusIcon status={meta.status} />
            </div>
            <div className={styles.content}>
                <div className={styles.titleRow}>
                    <span className={styles.title}>{t(meta.titleKey)}</span>
                    {meta.countLabel && (
                        <span className={styles.count}>{meta.countLabel}</span>
                    )}
                </div>
                <p className={styles.subtitle}>{t(meta.subtitleKey)}</p>
            </div>
        </div>
    );
};

export default UnitQrStatusBadge;
